
function CockpitDetails() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Cockpit.Overview.Details visual. <br/>
    /// 
    /// <br/>
    /// Author: ARF<br />
    /// Date: 9.11.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 9.10.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Cockpit.Cockpit1.vb
    this.day = "";
    this.visualHeight = 0;
    this.visualWidth = 0;
    this.iSingleHeightInSublist = 230;
}

CockpitDetails.prototype = new vcTemplate();

CockpitDetails.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    this.type = "list";
    this.interval = 1;
    this.datatype = 2;
    this.usePrices = false;
    try {
        if (me.error) { return false; }

        me.type = me.visual.find(".details .button-toggle-active").data("type");
      
        me.visualHeight = parseInt(me.visual.find('.details.right').height(), 10) ;
        me.visualWidth = parseInt(me.visual.find('.details.right').width(), 10);
      
        _VCMQ.produce(me.visual, me.vcgid, 'GET_DATE', "");

        me.visual.find(".btn").off("click").on("click",
            function() {
                me.type = $(this).data("type");
                me.visual.find(".btn").removeClass("button-toggle-active");
                $(this).addClass("button-toggle-active");
                me.selectChart($(this));
            });

      

        me.showInfo("", "", false);
       
        //me.doEvent(null);
        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

CockpitDetails.prototype.selectChart = function (obj) {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        me.visual.find(".details.right").css("overflow-y", "hidden");

        switch (me.type) {
            //case "chart":
            //    me.fillChart();
            //    break;
            case "sankey":
                me.fillSankey(obj);
                break;
            case "list":
                me.fillList(obj);
                break;

            case "hr":
                me.fillHr(obj);
                break;
            case "heatmap":
                me.fillHeatmap(obj);
                break;
            case "info":
                me.fillInfo(obj);
                break;
            default:
        }

        return true;
    } catch (ex) { me.writeError('selectChart', ex); return false }

}

CockpitDetails.prototype.fillSankey = function (obj) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        if (obj.data("childs") === false) {
            me.visual.find(".details.right").html("<div id='div-not-active' class='note'>" + me.resources.INFO_noDataflowFound + "</div>");
            return true;
        }

        me.container = me.getRandomIDContainerObj("div-chart-", true);
        me.visual.find(".right").html(me.container.obj);

        me.container.obj.html(me.vcC.getLoadingIcon());
      
        var param = { interval: 1, datatype: 2,  usePrices: me.usePrices, dateUserDef: false };
        switch (me.interval) {
            case 1: //daily
                param.startDate = me.day;
                param.endDate = me.day;
                break;
            case 3: //monthly
                param.startDate = me.dateRange.from;
                param.endDate = me.dateRange.to;
                break;
            case 5: //yearly
                param.startDate = me.dateRange.from;
                param.endDate = me.dateRange.to;
                param.interval = 3;
                break;
        default:
        }
        
        me.vcVisual.addVisualContentByName('div-chart-', "VISUAL_SIGNAL_SANKEY", me.container.random, me.day, me.visualHeight, me.visualWidth, "", JSON.stringify({ "signalID": me.bsaid, "archiveParam": param, OnlyFirstLevelChildren: true }), me.deviceType);

        return true;
    } catch (ex) { me.writeError('fillSankey', ex); return false }
};

CockpitDetails.prototype.fillList = function (obj) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    var list;
    var i;
    try {
        if (me.error) { return false; }

        me.visual.find(".details.right").css("overflow-y", "auto");

        if (obj.data("childs") === false) {
            me.visual.find(".details.right").html("<div id='div-not-active' class='note'>" + me.resources.INFO_noSubsignalsFound + "</div>");
            return true;
        }


        me.container = me.getRandomIDContainerObj("div-chart-", true);
        me.visual.find(".details.right").html(me.container.obj);

        list = $("<div>").attr("id", "div-list").css("max-height", me.visualHeight );


        for (i = 0; i < me.childs.length; i++) {
            list.append($("<div>").attr("id", "div_" + me.vcgid + "_XXX_" + me.childs[i]).data("id", me.childs[i]).addClass("div-visual"));
        };
      
        me.container.obj.html(list);
       
        for (i = 0; i < me.childs.length; i++) {
            me.vcVisual.addVisualBaseByName("div_", "VISUAL_COCKPIT_SINGLESIGNAL", me.vcgid + "_XXX_" + me.childs[i], me.day, me.iSingleHeightInSublist, me.visualWidth - 50, "", JSON.stringify({ 'signalid': me.childs[i], 'ShowDetails': false }), me.deviceType,
                function() {});
        };



        return true;
    } catch (ex) { me.writeError('fillList', ex); return false }
};

CockpitDetails.prototype.fillHr = function (obj) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    var signals = [];
    var param;
    var signalParam = { 'series': [] };
    var series;
   
    try {
        if (me.error) {
            return false;
        }

        me.visual.find(".details.right").html("<div class='subcaption'></div><div class='content'></div>");
        //alert(obj.data("hr"));
        //alert(obj.data("hr-childs"));
        if (me.showChildsInHrChart) {
            if ((obj.data("hr") === false && (obj.data("hr-childs") === false)) && me.interval === 1) {
                me.visual.find(".details.right .content").html("<div id='div-not-active' class='info'>" +
                    me.resources.INFO_noDataPossibleChangeInterval +
                    "</div>");
                return true;
            }
        } else {
           
            if ((obj.data("hr") === false) && me.interval === 1) {
              
                me.visual.find(".details.right .content").html("<div id='div-not-active' class='info'>" +
                    me.resources.INFO_noDataPossibleChangeInterval +
                    "</div>");
                return true;
            }
        }
        if (me.usePrices) {
            me.visual.find(".details.right .content").html("<div id='div-not-active' class='info'>" + me.resources.noPricesForThisChart + "</div>");
            return true;
        }
      

        me.container = me.getRandomIDContainerObj("div-chart-", true);
       me.visual.find(".right .content").html(me.container.obj);
       

        me.container.obj.html(me.vcC.getLoadingIcon());

        param = {
            'loggerID': me.blid, 'UsePrices': me.usePrices, 'FixTooltip': true, 'HideLegend': true, 'NoZoom': false,
            'GetSingleValuesAsConsumption': false, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'ShowIntervention': false,
            'ShowEmptyChart': true, 'ShowExportIcons': false
        }
        //alert(me.showChildsInHrChart);
        switch (me.interval) {
            case 1: //hr

                me.visual.find(".details.right .subcaption").html(me.resources.minuteValues);

                if (me.showChildsInHrChart) {
                    if (obj.data("hr")) {
                        signals.push(me.bsaid);
                    } else {
                        if (obj.data("hr-childs")) {
                            for (var i = 0; i < me.childs.length; i++) {
                                signals.push(me.childs[i]);
                               
                            }
                        }
                    }
                } else {
                    if (obj.data("hr")) {
                        signals.push(me.bsaid);
                    }
                }

                param.startDate = me.day;
                param.endDate = me.day;
                param.interval = 10;
                param.DataType = 1;

            
                param.highresolutionasrawdata = false;
                param.DateuserDef = true;
                param.MqEventOnPointClick = true;

                for (var j = 0; j < signals.length; j++) {
                    series = { 'bsaid': [signals[j]], 'rule': '[bsaid=' + signals[j] + ']', 'ruleType': 1 };
                    signalParam.series.push(series);
                }
               
                me.vcVisual.addVisualBaseByName('div-chart-', "VISUAL_RAMP_HR", me.container.random, me.day, me.visualHeight, me.visualWidth - 10, JSON.stringify(param), JSON.stringify(signalParam), me.deviceType);

                //me.vcVisual.addVisualBaseByName('div-chart-', "VISUAL_HR_FULL", me.container.random, me.day, me.visualHeight-0, me.visualWidth+40, "{'Signals':" + JSON.stringify(signals) + ", 'StartDate':'" + me.day + "', 'EndDate':'" + me.day + "', 'UseInUserHome':true}", "", me.deviceType);
                break;
            case 3: //monthly

              
                me.visual.find(".details.right .subcaption").html(me.resources.fiveteenMinValues);
                param.GetSingleValuesAsConsumption = true;
              
                param.startDate = me.dateRange.from;
                param.endDate = me.dateRange.to;
                param.interval = 1;
                param.datatype = 2;
                param.DateuserDef = true;
                param.MqEventOnPointClick = true;
                series = { 'bsaid': [me.bsaid], 'rule': '[bsaid=' + me.bsaid + ']', 'ruleType': 1 };
                signalParam.series.push(series);
                me.vcVisual.addVisualBaseByName('div-chart-', "VISUAL_RAMP_SINGLE", me.container.random, me.day, me.visualHeight, me.visualWidth-10, JSON.stringify(param), JSON.stringify(signalParam), me.deviceType);
                break;
            case 5: //yearly
                me.visual.find(".details.right .subcaption").html(me.resources.dailySums);
                param.startDate = me.dateRange.from;
                param.endDate = me.dateRange.to;
                //param.interval = 3;
                param.interval = 1;
                param.datatype = 2;
                param.DateuserDef = true;
                param.MqEventOnPointClick = true;
                series = { 'bsaid': [me.bsaid], 'rule': '[bsaid=' + me.bsaid + ']', 'ruleType': 1 };
                signalParam.series.push(series);
                me.vcVisual.addVisualBaseByName('div-chart-', "VISUAL_RAMP_DAILY", me.container.random, me.day, me.visualHeight, me.visualWidth-10, JSON.stringify(param), JSON.stringify(signalParam), me.deviceType);

                break;
            default:
                break;
        }


        //if (me.interval > 1) {
        //    me.container.obj.html("<div class='hr note'>" + me.resources.notAllowedInterval + "</div>");
        //    return true;
        //}



        return true;
    } catch (ex) { me.writeError('fillHr', ex); return false }
};

CockpitDetails.prototype.fillHeatmap = function (obj) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }


        me.visual.find(".details.right").html("<div class='subcaption'></div><div class='content'></div>");
      
        if (me.interval === 1) {
            me.visual.find(".details.right .content").html("<div id='div-not-active' class='info'>" + me.resources.INFO_noDataPossibleChangeInterval + "</div>");
            return true;
        }
        me.container = me.getRandomIDContainerObj("div-chart-", true);
        me.visual.find(".right").html(me.container.obj);


        me.container.obj.html(me.vcC.getLoadingIcon());

        var param = { bsaid: me.bsaid, dataType: 2, isStandAlone: false };
        switch (me.interval) {
        case 1: //daily
            param.startDate = me.day;
            param.endDate = me.day;
            break;
        case 3: //monthly
            param.startDate = me.dateRange.from;
            param.endDate = me.dateRange.to;
            break;
        case 5: //yearly
            param.startDate = me.dateRange.from;
            param.endDate = me.dateRange.to;
            param.interval = 3;
            break;
        default:
        }

      
        $("#div-chart-" + me.container.random).height(me.visualHeight).Heatmap({
            invokeType: "addVisualBase",
            parameter: param
        });
       
        return true;
    } catch (ex) { me.writeError('fillHeatmap', ex); return false }
};

CockpitDetails.prototype.fillInfo = function (obj) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.visual.find(".details.right").css("overflow-y", "auto");
        me.container = me.getRandomIDContainerObj("div-chart-", true);
        me.visual.find(".right").html(me.container.obj);


        me.container.obj.html(me.vcC.getLoadingIcon());
      

        window.VisualCoreService.getVisualContentByName("VISUAL_SIGNALANALOG_SUMMARY",
            parseInt(Math.random() * 100000, 10), getCurrentTimestamp(), me.visualHeight, 0, "", JSON.stringify({ 'tecDet': true, 'bsaid': me.bsaid, 'HideDataCenter':true }), me.deviceType,
             function (result) {
             
                $("#div-chart-" + me.container.random).html(result);
                eval($("#div-chart-" + me.container.random));

            });
        
        return true;
    } catch (ex) { me.writeError('fillInfo', ex); return false }
};


CockpitDetails.prototype.doEvent = function (event) {
    /// <summary>
    /// Not needed here right now ...
    /// </summary>
    var me = this;
    try {
       
        if (event !== null) {
            switch (event.msg) {
                case 'CHANGE_DATE':

                    if (event.values.vcgid === -1 || event.values.vcgid === me.vcgid) {
                        me.interval = event.values.interval;
                        me.usePrices = event.values.usePrices;

                        if (me.interval === 1) {
                            me.day = event.values.dates.singleDate;
                        } else {
                            me.dateRange = event.values.dates.returnDates;
                        }
                        if (me.interval > 1) {
                            me.datatype = 5;
                        }
                        
                        me.selectChart(me.visual.find(".button-toggle-active"));
                    }
                    break;
                default:
                    break;
            }
        }
    } catch (ex) { writeError('doEvent', ex); }
};

CockpitDetails.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.left, .right').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

